interface BPSCalculationProps {
  bps: number
  lpFee: number
  valiantBps?: number | null
}

function BPSCalculation({ bps, lpFee, valiantBps }: BPSCalculationProps) {
  const showValiant = valiantBps != null
  const lpOnlyBps = showValiant ? lpFee - valiantBps : lpFee

  return (
    <div>
      <div className="h-[1px] w-full bg-muted my-2" />

      <div className="flex flex-col items-center text-sm">
        <div>
          BPS Taken: <span className="font-bold">{bps} BPS</span>
        </div>
        <div className="text-sm text-muted-foreground">+</div>
        <div>
          LP Fee: <span className="font-bold">{lpOnlyBps} BPS</span>
        </div>
        {showValiant && (
          <>
            <div className="text-sm text-muted-foreground">+</div>
            <div>
              Valiant Fee: <span className="font-bold">{valiantBps} BPS</span>
            </div>
          </>
        )}

        <div className="text-sm text-muted-foreground">=</div>
        <div className="font-bold">
          Total BPS: <span>{bps + lpOnlyBps + (valiantBps ?? 0)} BPS</span>
        </div>
      </div>
    </div>
  )
}

export { BPSCalculation }
